import api from './api';

export interface HeroSlide {
    id: number;
    title: { en: string; fr: string; ar?: string; de?: string };
    subtitle: { en: string; fr: string; ar?: string; de?: string };
    button_text: { en: string; fr: string; ar?: string; de?: string };
    link_url: string;
    image_url: string;
    order: number;
    created_at: string;
    updated_at: string;
}

export interface PageContent {
    id: number;
    key: string;
    title: Record<string, string> | null;
    subtitle: Record<string, string> | null;
    content: Record<string, string> | null;
    metadata: any;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export const getHeroSlides = async () => {
    const response = await api.get<HeroSlide[]>('/hero-slides');
    return response.data;
};

// Public Methods
export const getPageContent = async (key: string) => {
    const response = await api.get<PageContent>(`/content/${key}`);
    return response.data;
};

export const fetchPublicPageContents = async () => {
    const response = await api.get<PageContent[]>('/content');
    return response.data;
};

// Admin Methods
export const getAllPageContent = async () => {
    const response = await api.get<PageContent[]>('/admin/page-contents');
    return response.data;
};

export const createPageContent = async (data: Partial<PageContent>) => {
    const response = await api.post<PageContent>('/admin/page-contents', data);
    return response.data;
};

export const updatePageContent = async (id: number, data: Partial<PageContent>) => {
    const response = await api.put<PageContent>(`/admin/page-contents/${id}`, data);
    return response.data;
};

export const deletePageContent = async (id: number) => {
    await api.delete(`/admin/page-contents/${id}`);
};
